import classNames from "classnames";
import moment from "moment";
import React from "react";
import { Loader } from "semantic-ui-react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  payment: server.dto.StripePaymentIntent
  onRetryFinished: (wasSuccessful: boolean) => void
}

const StripePaymentIntentRowCard = ({ payment, onRetryFinished }: Props) => {
  const [isRetrying, setIsRetrying] = React.useState(false);

  const stateColorClass = classNames({
    "var(--error-color)": payment.state === "createFailed" || payment.state === "requiresAction" || payment.state === "paymentFailed",
    "var(--blue)": payment.state === "createdWithSuccess",
    "var(--green)": payment.state === "paymentSucceeded"
  });

  const isOlderThan24Hrs = moment.utc().diff(moment.utc(payment.lastModifiedUtc), "hours") > 24;

  const displayRetryButton = isOlderThan24Hrs && (payment.state === "paymentFailed");

  const onRetryClicked = async () => {
    setIsRetrying(true);
    try {
      const res = await window.CoreApi.Stripe.PaymentIntentRetry(payment.stripePaymentIntentId);
      if (res.data.errors.length > 0) {
        alert("Retrying failed: " + res.data.errors.map(e => e.message).join("\n"));
        onRetryFinished(true);
      } else {
        onRetryFinished(false);
      }
    } catch (e) {
      alert("Exception when retrying payment: " + e);
      onRetryFinished(false);
    } finally {
      setIsRetrying(false);
    }
  };

  return <div key={payment.invoiceId} style={{ borderLeft: `solid 6px ${stateColorClass}` }}>
    <div className="grow1">
      <div className="flex">
        <div className="grow1">
          <div><h4><a href={routes.invoice_Detail(payment.invoiceId).absolute}>{payment.invoiceInternalId}</a></h4></div>
          <div>{payment.addressee.name}</div>
          <div>{payment.amount.formatted}</div>
          {/* <div className="text-sublabel">invoice {problem.invoiceId}</div> */}
        </div>
        <div style={{ textAlign: "right" }}>
          {moment.utc(payment.lastModifiedUtc).fromNow()}
        </div>
      </div>
      {payment.lastErrorMessage && <div className="margin-top-small s1_red">
        {payment.lastErrorMessage} / {payment.lastErrorCode}
      </div>}

      <div className="s1_smaller">
        <a href={`https://dashboard.stripe.com/payments/${payment.stripePaymentIntentId}`} target="_blank" rel="noreferrer">View in Stripe</a>
        {displayRetryButton && <>
          <span className="margin-left-small margin-right-small">|</span>
          {!isRetrying && <a onClick={onRetryClicked}>Retry</a>}
          {isRetrying && <Loader inverted active inline size="tiny" />}
        </>}
      </div>
    </div>
  </div>;
};

export default StripePaymentIntentRowCard;